import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  TUITranslateService,
} from '../../../../@aidesk/uikit-engine';

export default /*@__PURE__*/_defineComponent({
  __name: 'message-custom',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _toDisplayString(_unref(TUITranslateService).t("TUIChat.[自定义消息]")), 1))
}
}

})